import { createReducer } from '@reduxjs/toolkit'
import { FundFilters, FundGeographicDistribution, FundItem, FundSectorDistribution, IFundCarousel } from '../../models/Fund';
import { addFavorites, deleteFavorites, loadCarousel, loadFavorites, loadListOfFunds, setPage, setSelectedFund, toggleShowMore, updateFilters } from '../actions/libraryOfFunds';

export interface LibraryOfFundsReducer {
    allFunds: FundItem[] | undefined;
    funds: FundItem[] | undefined;
    selectedFund: number | undefined;
    showMore: boolean;
    page: number;
    favorites: number[] | undefined;
    filters: FundFilters;
    carousel: IFundCarousel | undefined;
}

const initialState: LibraryOfFundsReducer = {
    allFunds: undefined,
    funds: undefined,
    selectedFund: undefined,
    showMore: false,
    page: 0,
    favorites: undefined,
    filters: {},
    carousel: undefined
}

const libraryOfFundsReducer = createReducer<LibraryOfFundsReducer>(initialState, (builder) => {
    builder.addCase(setPage, (state, action) => {
        state.page = action.payload;
        state.showMore = false;
    });
    
    builder.addCase(setSelectedFund, (state, action) => {
        if (state.selectedFund === action.payload){
            state.selectedFund = undefined;
            state.showMore = false;
        }else{
            state.selectedFund = action.payload;
        }
    })

    builder.addCase(toggleShowMore, (state) => {
        state.showMore = !state.showMore;
    })

    builder.addCase(loadListOfFunds.pending, (state) => {
        state.allFunds = undefined;
        state.funds = undefined;
        state.selectedFund = undefined;
        state.showMore = false;
        state.page = 0
    });
    builder.addCase(loadListOfFunds.fulfilled, (state, action) => {
        state.funds = action.payload;
        state.allFunds = action.payload;
    });

    builder.addCase(loadFavorites.pending, (state) => {
        state.favorites = undefined;
    });
    builder.addCase(loadFavorites.fulfilled, (state, action) => {
        state.favorites = action.payload;
    });

    builder.addCase(addFavorites.pending, () => {
    });
    builder.addCase(addFavorites.fulfilled, (state, action) => {
        if (state.favorites === undefined){
            return;
        }
        state.favorites?.push(action.payload);
    });

    builder.addCase(deleteFavorites.pending, () => {
    });
    builder.addCase(deleteFavorites.fulfilled, (state, action) => {
        if (state.favorites === undefined){
            return;
        }
        const index = state.favorites.indexOf(action.payload);
        if (index !== -1){
            state.favorites.splice(index, 1);
        }
    });
    builder.addCase(updateFilters, (state, action) => {
        state.filters = action.payload;
        state.selectedFund = undefined;
        state.showMore = false;
        if (state.allFunds){
            let selectedFunds = [...state.allFunds];
            if (state.filters.sector !== undefined && state.filters.sector.length > 0){
                selectedFunds = selectedFunds.filter(f => f.sectorDistribution.filter((s: FundSectorDistribution) => (state.filters.sector as string[]).indexOf(s.sector) !== -1).length > 0);
            }
            if (state.filters.size !== undefined && state.filters.size.length > 0){
                selectedFunds = selectedFunds.filter(f => f.fundSize >= (state.filters.size as number[])[0] && f.fundSize <= (state.filters.size as number[])[1]);
            }
            if (state.filters.stage !== undefined && state.filters.stage.length > 0){
                selectedFunds = selectedFunds.filter(f => (f.stageDistribution.early > 0 && state.filters.stage?.indexOf("Early") !== -1)
                    || (f.stageDistribution.growth > 0 && state.filters.stage?.indexOf("Growth") !== -1)
                    || (f.stageDistribution.late > 0 && state.filters.stage?.indexOf("Late") !== -1))
            }
            
            if (state.filters.area !== undefined && state.filters.area.length > 0){
                selectedFunds = selectedFunds.filter(f => f.geographicDistribution.filter((s: FundGeographicDistribution) => (state.filters.area as string[]).indexOf(s.zone) !== -1).length > 0);
            }
            if (state.filters.eltif){
                selectedFunds = selectedFunds.filter(f => f.eltif);
            }
            if (state.filters.new){
                selectedFunds = selectedFunds.filter(f => f.publicationDate.getTime() > (Date.now() - (1000 * 3600 * 24 * 90)))
            }
            if (state.filters.closingSoon){
                selectedFunds = selectedFunds.filter(f => f.closingDate.getTime() < (Date.now() + (1000 * 3600 * 24 * 90)));
            }
            if (state.filters.favorites && state.favorites !== undefined){
                selectedFunds = selectedFunds.filter(f => (state.favorites as number[]).indexOf(f.id) !== -1);
            }
            if (state.filters.freeText){
                const lowerFreeText = (state.filters.freeText as string).toLocaleLowerCase();
                selectedFunds = selectedFunds.filter(f => f.name.toLocaleLowerCase().indexOf(lowerFreeText) !== -1
                    || f.sectorDistribution.findIndex(s => s.sector.toLocaleLowerCase().indexOf(lowerFreeText) !== -1) !== -1
                    || f.geographicDistribution.findIndex(g => g.zone.toLocaleLowerCase().indexOf(lowerFreeText) !== -1) !== -1)
            }
            state.funds = selectedFunds;
        }
    });
    builder.addCase(loadCarousel.pending, (state) => {
        state.carousel = undefined
    });
    builder.addCase(loadCarousel.fulfilled, (state, action) => {
        state.carousel = action.payload
    });
});

export default libraryOfFundsReducer;
